module.exports = __webpack_public_path__ + "85194e219872f66f66c3099dfa84968e.png";